/**
 * Elevation / shadow scale for modals, alerts, and raised surfaces.
 *
 * **Design references (Figma – Visual Template):**
 * - Elevation: `node-id=1735-2637`
 * - Alerts: `node-id=2386-10683`, `node-id=64-2062` (spacing system), `node-id=2422-2112`, `node-id=2433-2366`
 * - Layout / responsiveness: `node-id=7083-29970`, `node-id=1157-88137`
 *
 * `web` uses `boxShadow`, native uses `elevation` + `shadow*`.
 */
import { Platform, type ViewStyle } from 'react-native';

const dialogWeb: ViewStyle = {
  boxShadow:
    '0 8px 32px rgba(15, 23, 42, 0.14), 0 0 0 1px rgba(15, 23, 42, 0.06)',
};

const dialogNative: ViewStyle = {
  shadowColor: '#0f172a',
  shadowOffset: { width: 0, height: 8 },
  shadowOpacity: 0.18,
  shadowRadius: 24,
  elevation: 12,
};

const popoverWeb: ViewStyle = {
  boxShadow:
    '0 6px 24px rgba(15, 23, 42, 0.12), 0 0 0 1px rgba(15, 23, 42, 0.04)',
};

const popoverNative: ViewStyle = {
  shadowColor: '#0f172a',
  shadowOffset: { width: 0, height: 4 },
  shadowOpacity: 0.14,
  shadowRadius: 12,
  elevation: 8,
};

/** Visual Template Select panel (`8574:33292`): `0 4px calc(blur/md ÷ 2)` ≈ **6px**, **20%** black. */
const dropdownPanelWeb: ViewStyle = {
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
};

export const elevation = {
  /** Centered dialog / help sheet (field info, confirmations). */
  dialog: Platform.select<ViewStyle>({
    web: dialogWeb,
    default: dialogNative,
  }) as ViewStyle,
  /** Anchored popover, dropdown panel, or hover help (web). */
  popover: Platform.select<ViewStyle>({
    web: popoverWeb,
    default: popoverNative,
  }) as ViewStyle,
  /** Portaled single-select / multi-select menu chrome (web). */
  dropdownPanel: Platform.select<ViewStyle>({
    web: dropdownPanelWeb,
    default: {},
  }) as ViewStyle,
};
